import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

export default function Programs() {
  const { t } = useLang();
  return (
    <section id="programs" data-testid="programs-section" className="relative bg-icdh-navy text-icdh-white py-28 md:py-40">
      <div className="noise-overlay absolute inset-0 opacity-[0.04] pointer-events-none" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="max-w-2xl">
          <Reveal><Overline dark>{t.programs.overline}</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight">{t.programs.title}</h2>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-px bg-icdh-white/10 border border-icdh-white/10">
          {t.programs.items.map((p, i) => (
            <Reveal key={i} delay={(i % 2) * 0.1}>
              <div className="group bg-icdh-navy p-10 md:p-14 hover:bg-icdh-surfacedark transition-colors duration-500 h-full">
                <div className="flex items-start justify-between">
                  <span className="text-xs uppercase tracking-[0.25em] text-icdh-red">{p.n}</span>
                  <ArrowUpRight className="text-icdh-white/40 group-hover:text-icdh-red group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500" />
                </div>
                <h3 className="mt-8 font-serif text-3xl md:text-4xl tracking-tight">{p.t}</h3>
                <p className="mt-4 text-icdh-white/60 max-w-sm">{p.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
